const canUseStore = (context = {}) => typeof context.getStore !== 'undefined';

export default canUseStore;
